import { render, staticRenderFns } from "./NavBarLeftAdmin.vue?vue&type=template&id=11dd8486&"
import script from "./NavBarLeftAdmin.vue?vue&type=script&lang=js&"
export * from "./NavBarLeftAdmin.vue?vue&type=script&lang=js&"
import style0 from "./NavBarLeftAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VList,VListItem,VListItemTitle,VNavigationDrawer})
